var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 113,
    viewBox: "0 0 127 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 30.0698C86.5364 33.097 89.8125 37.0225 92.0689 41.5353C94.3253 46.0481 95.5 51.0243 95.5 56.0698C95.5 61.1152 94.3253 66.0914 92.0689 70.6042C89.8125 75.117 86.5364 79.0425 82.5 82.0698M100.05 10.5698C106.836 16.0535 112.309 22.9856 116.069 30.8584C119.829 38.7311 121.78 47.3452 121.78 56.0698C121.78 64.7943 119.829 73.4084 116.069 81.2812C112.309 89.154 106.836 96.086 100.05 101.57M24 75.5698H11C9.27609 75.5698 7.62279 74.8849 6.40381 73.666C5.18482 72.447 4.5 70.7937 4.5 69.0698V43.0698C4.5 41.3459 5.18482 39.6926 6.40381 38.4736C7.62279 37.2546 9.27609 36.5698 11 36.5698H24L46.75 7.31977C47.3181 6.21627 48.2622 5.35237 49.4117 4.88417C50.5611 4.41597 51.8402 4.37436 53.0176 4.76685C54.1951 5.15934 55.1934 5.96004 55.832 7.02428C56.4707 8.08852 56.7076 9.34609 56.5 10.5698V101.57C56.7076 102.793 56.4707 104.051 55.832 105.115C55.1934 106.179 54.1951 106.98 53.0176 107.373C51.8402 107.765 50.5611 107.724 49.4117 107.255C48.2622 106.787 47.3181 105.923 46.75 104.82L24 75.5698Z",
    stroke: "#650B0D",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeon);
export default __webpack_public_path__ + "static/media/volumeon.8325690eeaa399f08fa81bed2fbbf56b.svg";
export { ForwardRef as ReactComponent };